import React from 'react';
import { Tag } from 'antd';
import type { ProposalStatus } from '../../types/proposal';

const STATUS_COLORS: Record<ProposalStatus, string> = {
  WAITING: 'default',
  DRAFT: 'orange',
  RESPONSES_RECEIVED: 'blue',
  ACCEPTED: 'green',
  REJECTED: 'red'
};

const STATUS_LABELS: Record<ProposalStatus, string> = {
  WAITING: 'Waiting',
  DRAFT: 'Draft',
  RESPONSES_RECEIVED: 'Response sent',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected'
};

interface ProposalStatusTagProps {
  status: ProposalStatus;
}

export const ProposalStatusTag: React.FC<ProposalStatusTagProps> = ({ status }) => {
  return <Tag color={STATUS_COLORS[status]}>{STATUS_LABELS[status]}</Tag>;
};
